export var ADORNMENT_POSITIONS = Object.freeze({
  left: 'left',
  right: 'right'
});